<template>
  <div class="section-container">
    <!-- Header with Add Button -->
    <b-row align-v="center" class="mb-2">
      <b-col md="12">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="text-uppercase font-weight-bold mb-0" style="display: flex; align-items: center">
            <i class="fas fa-user-tie mr-2" style="font-size: 20px !important;"></i> Consultancies
          </h5>
          <b-button size="sm" variant="info" @click="showAddModal">
            <i class="fas fa-plus mr-1" style="font-size: 12px !important;"></i> Add
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-row v-if="consultancies && consultancies.length > 0" align-v="center" class="mb-3">
      <b-col md="12">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No.</th>
              <th>Description</th>
              <th>Academic Year</th>
              <th>Is Funded</th>
              <th>Fund Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="consultancy in sortedConsultancies" :key="consultancy.id">
              <td>{{ consultancy.si_no }}</td>
              <td>{{ consultancy.description }}</td>
              <td>{{ consultancy.academic_year }}</td>
              <td>{{ consultancy.is_funded }}</td>
              <td>{{ consultancy.fund_amount }}</td>
              <td>
                <i class="fas fa-edit pointer text-info" style="font-size: 18px !important;"
                  @click="editConsultancy(consultancy)"></i>
                <i class="fas fa-trash fa-sm ml-2" style="cursor: pointer; color: #dc3545;"
                  @click="deleteConsultancy(consultancy)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <!-- Modal -->
    <b-modal v-model="showModal" title="Consultancy" @hide="resetForm" hide-footer>
      <b-form @submit.prevent="createOrUpdateConsultancy">
        <b-form-group label="Sl No">
          <b-form-input type="number" v-model="consultancy.si_no"></b-form-input>
        </b-form-group>
        <b-form-group label="Description">
          <b-form-input v-model="consultancy.description"></b-form-input>
        </b-form-group>
        <b-form-group label="Academic Year">
          <b-form-input v-model="consultancy.academic_year"></b-form-input>
        </b-form-group>
        <b-form-group label="Is Funded">
          <b-form-input v-model="consultancy.is_funded"></b-form-input>
        </b-form-group>
        <b-form-group label="Fund Amount">
          <b-form-input v-model="consultancy.fund_amount"></b-form-input>
        </b-form-group>

        <div class="text-center">
          <b-button type="submit" variant="success">
            {{ editIndex === null ? 'Add' : 'Update' }}
          </b-button>
          <b-button variant="danger" class="ml-2" @click="showModal = false">Cancel</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["profile", "profileId"],
  data() {
    return {
      showModal: false,
      editIndex: null,
      consultancies: this.profile.consultancies || [],
      consultancy: { si_no: "", description: "", academic_year: "", is_funded: "", fund_amount: "" },
    };
  },
  computed: {
    sortedConsultancies() {
      return [...this.consultancies].sort((a, b) => Number(a.si_no) - Number(b.si_no));
    }
  },
  methods: {
    async getProfile() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/myprofile?profileId=${this.profileId}`;
        const response = await this.$axios.get(url);
        this.profile.consultancies = response.data.consultancies;
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },
    async createOrUpdateConsultancy() {
      try {
        const url = this.$store.getters.getAPIKey.mainAPI + `/userprofiles/consultancies`;
        let response;

        if (this.editIndex === null) {
          // Create
          response = await this.$axios.post(url, {
            ...this.consultancy,
            si_no: Number(this.consultancy.si_no),
            user_profile_id: this.profile.id,
          });
          this.consultancies.unshift(response.data);
        } else {
          // Update
          const updateUrl = `${url}/${this.consultancy.id}`;
          response = await this.$axios.put(updateUrl, {
            ...this.consultancy,
            si_no: Number(this.consultancy.si_no),
          });
          this.consultancies.splice(this.editIndex, 1, response.data);
        }

        this.$toast.success("Profile Updated", { position: "top", duration: 3000 });
        this.getProfile();
        this.showModal = false;
      } catch (error) {
        console.error("Error updating consultancy:", error);
        this.$toast.error("Failed to update profile", { position: "top", duration: 3000 });
      }
    },
    showAddModal() {
      this.resetForm();
      this.showModal = true;
    },
    editConsultancy(consultancy) {
      this.consultancy = { ...consultancy };
      this.editIndex = this.consultancies.findIndex(c => c.id === consultancy.id);
      this.showModal = true;
    },
    async deleteConsultancy(consultancy) {
      try {
        const deleteUrl = `${this.$store.getters.getAPIKey.mainAPI}/userprofiles/consultancies/${consultancy.id}`;
        await this.$axios.delete(deleteUrl);

        const index = this.consultancies.findIndex(c => c.id === consultancy.id);
        if (index !== -1) {
          this.consultancies.splice(index, 1);
        }
        this.getProfile();
        this.$toast.success("Consultancy deleted", { position: "top", duration: 3000 });
      } catch (error) {
        console.error("Error deleting consultancy:", error);
        this.$toast.error("Failed to delete consultancy", { position: "top", duration: 3000 });
      }
    },
    resetForm() {
      this.consultancy = { si_no: "", description: "", academic_year: "", is_funded: "", fund_amount: "" };
      this.editIndex = null;
    }
  }
};
</script>

<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
  margin-bottom: 20px;
}
</style>
